import React, { useEffect, useState } from "react";
import icons from "../../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { setHomePopUp } from "../../signIn/cl_SignInSlice";
import { endpoints } from "../../../api/ApiEndPoints";
import { setTopGamesListContent } from "./cl_topGamesList";
import useFilterGamesByType from "../../../services/helper/filterGamesByType";
import { getFromLocalStorage } from "../../../services/helper/cl_Helper";

const TopGamesList = () => {
  const [gameList, setGameList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getFromLocalStorage("gk");

  const brandid = endpoints?.fasFasBrandId || 307;
  const { staticContent } = useSelector((state) => state?.topGamesList);

  useEffect(() => {
    dispatch(setTopGamesListContent(brandid));
  }, []);

  useEffect(() => {
    if (Array.isArray(staticContent)) {
      const updatedList = staticContent
        ?.filter(({ is_active, before_login, after_login }) => {
          if (!is_active) return false;

          if (!token) {
            return before_login === true;
          }

          return after_login === true;
        })
        ?.map(({ menu_name, menu_link, icontags, is_active }) => ({
          labelName: menu_name,
          path: menu_link,
          icons: icontags,
          is_active: is_active,
        }));
      setGameList(updatedList);
    }
  }, [staticContent, token]);

  const filterByGameType = useFilterGamesByType();

  const handleGameClick = (labelName, menuLink) => {
    if (
      labelName.toLowerCase() === "promotions" ||
      labelName.toLowerCase() === "offers"
    ) {
      const route = "/promotions";
      if (!token) {
        localStorage.setItem(
          "intendedRoute",
          JSON.stringify({
            labelName,
            menuLink: route,
            isGame: false,
          })
        );
      }
      navigate(route);
      return;
    }

    if (labelName.toLowerCase() === "loyalty") {
      if (!token) {
        localStorage.setItem(
          "intendedRoute",
          JSON.stringify({
            labelName,
            menuLink: "/loyaltyprelogin",
            isGame: false,
          })
        );
        navigate("/loyaltyprelogin");
        return;
      }
    }

    if (!token) {
      localStorage.setItem(
        "intendedRoute",
        JSON.stringify({
          labelName,
          menuLink,
          isGame: menuLink === "/",
        })
      );
      navigate("/signin");
      return;
    }

    if (menuLink === "/") {
      const filteredGames = filterByGameType(labelName);
      const gamesList =
        filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];

      navigate(`/games/${labelName}`, {
        state: {
          gamesList,
          title: labelName,
          game_type: labelName,
        },
      });
    } else {
      const stateData = encodeURIComponent(
        JSON.stringify({ gameData: { labelName, menuLink }, gameClose: true })
      );
      window.location.href = `/gamelaunch?state=${stateData}`;
    }
  };

  return (
    <div className="SB-subHeader">
      <div className="SB-subHeader-container">
        <ul>
          {gameList?.length > 0
            ? gameList.map((game, index) => (
                <li
                  key={index}
                  className="SB-crashItem"
                  onClick={() => handleGameClick(game?.labelName, game?.path)}
                >
                  <a
                    onClick={(e) => e.preventDefault()}
                    className="SB-subHeader-item"
                  >
                    <div className="SB-iconSVG">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#FFF"
                      >
                        <use xlinkHref={`${icons}#${game?.icons}`} />
                      </svg>
                    </div>
                    <div className="SB-subHeader-item__txt">
                      {game?.labelName}
                    </div>
                  </a>
                </li>
              ))
            : null}
        </ul>
      </div>
    </div>
  );
};

export default TopGamesList;
